/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UserProfileAdapter } from './user-profile.adapter';
import {Title, UserSignUp} from "../../root/model";
import {User} from "../../../account/root/model";

@Injectable()
export class UserProfileConnector {
  constructor(protected userProfileAdapter: UserProfileAdapter) {}

  update(username: string, user: User): Observable<unknown> {
    return this.userProfileAdapter.update(username, user);
  }

  register(user: UserSignUp): Observable<User> {
    return this.userProfileAdapter.register(user);
  }

  registerGuest(guid: string, password: string): Observable<User> {
    return this.userProfileAdapter.registerGuest(guid, password);
  }

  requestForgotPasswordEmail(userEmailAddress: string): Observable<unknown> {
    return this.userProfileAdapter.requestForgotPasswordEmail(userEmailAddress);
  }

  resetPassword(token: string, newPassword: string): Observable<unknown> {
    return this.userProfileAdapter.resetPassword(token, newPassword);
  }

  updateEmail(
    userId: string,
    currentPassword: string,
    newUserId: string
  ): Observable<unknown> {
    return this.userProfileAdapter.updateEmail(
      userId,
      currentPassword,
      newUserId
    );
  }

  updatePassword(
    userId: string,
    oldPassword: string,
    newPassword: string
  ): Observable<unknown> {
    return this.userProfileAdapter.updatePassword(
      userId,
      oldPassword,
      newPassword
    );
  }

  remove(userId: string): Observable<unknown> {
    return this.userProfileAdapter.close(userId);
  }

  getTitles(): Observable<Title[]> {
    return this.userProfileAdapter.loadTitles();
  }
}
